<script>
    import PreviewSection from "./PreviewSection";
    import SimpleSection from "../../components/pagesbuilder/sections/SimpleSection";

    export default {
        name: "PreviewSimpleSection",
        mixins: [PreviewSection, SimpleSection],
        methods: {
            getRenderVideoParams(){
                return this.myData.videoMediaData.params || {};
            }
        }
    }
</script>

